"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var date_from_json_1 = require("./date-from-json");
var DatetimeToInput = function (datetime) {
    try {
        var date = date_from_json_1.DateFromJson(datetime);
        var offset = date.getTimezoneOffset();
        return (new Date(+date - offset * 60 * 1000))
            .toISOString()
            .substring(0, 16);
    }
    catch (e) {
        return null;
    }
};
exports.DatetimeToInput = DatetimeToInput;
//# sourceMappingURL=datetime-to-input.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/helpers/datetime-to-input.js
// module id = 880
// module chunks = 3